// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__3bM7P","paymentContainer":"PaymentPage_paymentContainer__2sIEL"};